import React from "react";
import { Link } from "react-router-dom";
import InterpretationImage2 from "../assets/images/home1.webp";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const InitialSection: React.FC = () => {
  const { t, ready } = useTranslation();
  if (!ready) return null;
  
  // Get benefits as an array with fallback
  const benefits = t('initialSection.benefits', { returnObjects: true, defaultValue: [] }) as string[];
  
  // Ensure benefits is an array
  const safeBenefits = Array.isArray(benefits) ? benefits : [];
  
  return (
    <section className="container mx-auto flex flex-col lg:flex-row items-center px-4 space-y-8 lg:space-y-0 lg:space-x-12">
      <div className="text-center lg:text-start lg:w-1/2 space-y-4">
        <h1 className="text-3xl font-extrabold leading-tight tracking-tight text-gray-900 lg:text-5xl">
          {t('initialSection.title')}
        </h1>
        <p className="text-lg text-gray-500">
          {t('initialSection.subtitle')}
        </p>

        <div className="flex flex-wrap justify-center lg:justify-start lg:-ml-4 gap-2 mt-4">
          {safeBenefits.map((benefit: string, index: number) => (
            <div
              key={index}
              className="flex items-center space-x-2 text-gray-700 bg-gray-100 px-3 py-2 rounded-md"
            >
              <CheckCircle className={`h-5 w-5 ${
                index === 0 ? 'text-blue-500' : 
                index === 1 ? 'text-green-500' : 
                index === 2 ? 'text-purple-500' : 
                'text-yellow-500'
              }`} />
              <span className="text-sm font-medium">{benefit}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-center lg:justify-start space-x-4 mt-8">
          <Link
            to="/free-quote"
            className="bg-[#025f99] text-white px-6 py-3 rounded-lg text-lg hover:bg-[#014a73]"
          >
            {t('initialSection.cta')}
          </Link>
        </div>
      </div>

      <div className="w-full lg:w-1/3 lg:w-1/2 flex justify-center">
        <img
          src={InterpretationImage2}
          alt={t('initialSection.imageAlt')}
          className="max-w-full lg:max-w-md rounded-lg object-cover animate-slide-in lg:ml-10 mb-4"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default InitialSection;
